import { ArrayParam, ObjectParam, StringParam, NumberParam } from 'use-query-params'

import { dateFormat } from '@app/constants'
import { FILTERS_PARAMS_KEYS } from '@app/api/constants'
import { columnSearchSchemaOptionType } from '@app/hooks/useTableSearch/сonstants'

import type { ColumnTitleSchema } from '@app/types/table'
import type { RegistryArchiveListsDataSource } from './types'
import type { ColumnTableSearchSchema, TableSearchQuerySchema } from '@app/hooks/useTableSearch/types'

export const columnTitleMap: ColumnTitleSchema<RegistryArchiveListsDataSource> = {
  monitoringType: 'Тип мониторинга',
  promotionName: 'Рекламное мероприятие',
  promoDateFrom: 'Дата начала РМ Лента',
  promoDateTo: 'Дата оконч. РМ Лента',
  store: 'ТК Лента',
  cluster: 'Кластер',
  clustersGroup: 'Группа кластеров',
  salesOrganization: 'Сбытовая организация',
  week: 'Неделя',
  approvalAt: 'Дата согласования',
  comment: 'Примечание'
}

export const topFiltersQuerySchema = {
  [FILTERS_PARAMS_KEYS.monitoringTypeIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.storeIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.clusterIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.clustersGroupIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.promoIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.salesOrganizationIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.week]: StringParam
}

export const tableSearchQuerySchema: TableSearchQuerySchema<RegistryArchiveListsDataSource> = {
  'table-monitoringType': StringParam,
  'table-promotionName': StringParam,
  'table-promoDateFrom': ObjectParam,
  'table-promoDateTo': ObjectParam,
  'table-store': StringParam,
  'table-cluster': StringParam,
  'table-clustersGroup': StringParam,
  'table-salesOrganization': StringParam,
  'table-week': NumberParam,
  'table-approvalAt': ObjectParam,
  'table-comment': StringParam
} as const

const titleWrapperProps = { minWidth: 200 } as const
const titleWrapperDateProps = { minWidth: 215 } as const

export const columnsSearchSchema: ColumnTableSearchSchema<RegistryArchiveListsDataSource> = {
  monitoringType: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  promotionName: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  promoDateFrom: {
    type: columnSearchSchemaOptionType.DATE_RANGE,
    titleWrapperProps: titleWrapperDateProps,
    controlProps: { format: dateFormat.DD_MM_YYYY }
  },
  promoDateTo: {
    type: columnSearchSchemaOptionType.DATE_RANGE,
    titleWrapperProps: titleWrapperDateProps,
    controlProps: { format: dateFormat.DD_MM_YYYY }
  },
  store: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  cluster: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  clustersGroup: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  salesOrganization: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  week: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  approvalAt: {
    type: columnSearchSchemaOptionType.DATE_RANGE,
    titleWrapperProps: titleWrapperDateProps,
    controlProps: { format: dateFormat.DD_MM_YYYY }
  },
  comment: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps }
}
